import {
  Alert,
  AlertIcon,
  AlertTitle,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { get } from "lodash";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { REQUEST_DELETE_ACCOUNT } from "../../../../store/account/accountActionType";
import { useAccounts } from "../../../../store/account/reducer";
import { IAccount } from "../../../../types/account";
interface Props {
  account: IAccount;
  isOpen: any;
  onClose: any;
}
const AccountDeleteConfirmation: React.FC<Props> = ({
  isOpen,
  onClose,
  account,
}) => {
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const { busy, message } = useAccounts();

  return (
    <Modal
      id="deletAcMenu"
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={false}
      size={"sm"}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Account</ModalHeader>
        <ModalCloseButton disabled={busy} />
        <ModalBody>
          <Text color="red">Are you sure to remove this User ?</Text>
          <Text> {get(account, "user.email")}</Text>
          {message && (
            <Alert status="error" zIndex={100}>
              <AlertIcon />
              <AlertTitle mr={2}>{message}</AlertTitle>
            </Alert>
          )}
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" mr={3} onClick={onClose} disabled={busy}>
            Close
          </Button>
          <Button
            colorScheme="red"
            variant={"outline"}
            mr={3}
            onClick={() => {
              if (get(account, "user._id")) {
                dispatch({
                  type: REQUEST_DELETE_ACCOUNT,
                  payload: { accountId: get(account, "_id") },
                  onSuccess: () => {
                    navigate("../");
                  },
                });
              }
            }}
            disabled={busy}
          >
            Submit
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
export default AccountDeleteConfirmation;
